"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkPreviewCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const lucide_react_1 = require("lucide-react");
const useStore_1 = require("../../store/useStore");
// Client-side cache for instant display without re-fetching
const previewCache = new Map();
const LinkPreviewCard = ({ url, onImageClick }) => {
    const [data, setData] = (0, react_1.useState)(() => previewCache.get(url) || null);
    const [loading, setLoading] = (0, react_1.useState)(!previewCache.has(url));
    const [isPlayingSoundCloud, setIsPlayingSoundCloud] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (previewCache.has(url)) {
            setData(previewCache.get(url));
            setLoading(false);
            return;
        }
        // 1. Instant client-side detection for YouTube
        const ytMatch = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/i);
        if (ytMatch) {
            const videoId = ytMatch[1];
            const initialYt = {
                url,
                provider: 'YouTube',
                provider_url: 'https://www.youtube.com',
                title: 'YouTube Videosu',
                thumbnail: `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`,
                embed_type: 'youtube',
                video_id: videoId,
                color: '#ff0000',
            };
            setData(initialYt);
            previewCache.set(url, initialYt);
            setLoading(false);
            // Async fetch complete title/author
            fetch(`https://www.youtube.com/oembed?url=${encodeURIComponent(url)}&format=json`)
                .then(r => r.json())
                .then(oembed => {
                if (oembed && oembed.title) {
                    const updated = {
                        ...initialYt,
                        title: oembed.title,
                        author: oembed.author_name,
                        author_url: oembed.author_url,
                        thumbnail: oembed.thumbnail_url || initialYt.thumbnail,
                    };
                    setData(updated);
                    previewCache.set(url, updated);
                }
            })
                .catch(() => { });
            return;
        }
        // 2. Instant client-side detection for SoundCloud
        const scMatch = url.match(/soundcloud\.com\/([a-zA-Z0-9_-]+)\/([a-zA-Z0-9_-]+)/i);
        if (scMatch) {
            const authorSlug = scMatch[1];
            const trackSlug = scMatch[2].replace(/-/g, ' ');
            const formattedTitle = trackSlug.charAt(0).toUpperCase() + trackSlug.slice(1);
            const initialSc = {
                url,
                provider: 'SoundCloud',
                provider_url: 'https://soundcloud.com',
                author: authorSlug,
                author_url: `https://soundcloud.com/${authorSlug}`,
                title: formattedTitle,
                embed_type: 'soundcloud',
                color: '#ff5500',
            };
            setData(initialSc);
            previewCache.set(url, initialSc);
            // Fetch SoundCloud metadata via our backend preview API to avoid client-side 403 CORS blocks
            fetch(`${useStore_1.API_BASE_URL}/preview.php?url=${encodeURIComponent(url)}`)
                .then(r => r.json())
                .then(res => {
                if (res && res.title) {
                    setData(res);
                    previewCache.set(url, res);
                }
            })
                .catch(() => { })
                .finally(() => setLoading(false));
            return;
        }
        // 3. Instant client-side detection for Spotify
        const spMatch = url.match(/open\.spotify\.com\/(track|album|playlist)\/([a-zA-Z0-9]+)/i);
        if (spMatch) {
            const type = spMatch[1];
            const id = spMatch[2];
            const spData = {
                url,
                provider: 'Spotify',
                provider_url: 'https://open.spotify.com',
                title: 'Spotify Çalma Listesi / Şarkı',
                embed_type: 'spotify',
                embed_url: `https://open.spotify.com/embed/${type}/${id}`,
                color: '#1db954',
            };
            setData(spData);
            previewCache.set(url, spData);
            setLoading(false);
            return;
        }
        // 4. Direct video / audio / image check
        const cleanUrl = url.split('?')[0].toLowerCase();
        if (cleanUrl.match(/\.(mp4|webm|mov|m4v)$/i)) {
            const vData = { url, embed_type: 'video', embed_url: url };
            setData(vData);
            previewCache.set(url, vData);
            setLoading(false);
            return;
        }
        if (cleanUrl.match(/\.(mp3|wav|ogg|m4a|aac)$/i)) {
            const aData = { url, embed_type: 'audio', embed_url: url };
            setData(aData);
            previewCache.set(url, aData);
            setLoading(false);
            return;
        }
        if (cleanUrl.match(/\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i)) {
            const iData = { url, embed_type: 'image', thumbnail: url };
            setData(iData);
            previewCache.set(url, iData);
            setLoading(false);
            return;
        }
        // 5. Generic Webpage - Query backend preview endpoint
        let isMounted = true;
        fetch(`${useStore_1.API_BASE_URL}/preview.php?url=${encodeURIComponent(url)}`)
            .then(r => r.json())
            .then(res => {
            if (!isMounted)
                return;
            if (res && (res.title || res.thumbnail || res.description)) {
                setData(res);
                previewCache.set(url, res);
            }
        })
            .catch(() => { })
            .finally(() => {
            if (isMounted)
                setLoading(false);
        });
        return () => {
            isMounted = false;
        };
    }, [url]);
    if (!data || loading)
        return null;
    const accentColor = data.color || '#4e5058';
    // Direct Video
    if (data.embed_type === 'video') {
        return ((0, jsx_runtime_1.jsx)("div", { className: "discord-link-embed direct-media-embed", children: (0, jsx_runtime_1.jsx)("video", { controls: true, src: data.embed_url || data.url, className: "direct-embed-video", preload: "metadata" }) }));
    }
    // Direct Audio
    if (data.embed_type === 'audio') {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "discord-link-embed direct-media-embed", style: { borderLeft: '4px solid #5865f2' }, children: [(0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px', color: '#949ba4', fontSize: '12px' }, children: [(0, jsx_runtime_1.jsx)(lucide_react_1.Volume2, { size: 14, color: "#5865f2" }), (0, jsx_runtime_1.jsx)("span", { children: "Ses Dosyas\u0131" })] }), (0, jsx_runtime_1.jsx)("audio", { controls: true, src: data.embed_url || data.url, style: { width: '100%', height: '36px' } })] }));
    }
    // Direct Image
    if (data.embed_type === 'image') {
        return ((0, jsx_runtime_1.jsx)("div", { className: "discord-link-embed direct-media-embed", children: (0, jsx_runtime_1.jsx)("img", { src: data.thumbnail || data.url, alt: "", className: "direct-embed-image", onClick: () => onImageClick?.(data.thumbnail || data.url) }) }));
    }
    // Spotify Player
    if (data.embed_type === 'spotify') {
        return ((0, jsx_runtime_1.jsx)("div", { className: "discord-link-embed spotify-embed", style: { borderLeft: `4px solid ${accentColor}` }, children: (0, jsx_runtime_1.jsx)("iframe", { src: data.embed_url, width: "100%", height: "152", frameBorder: "0", allow: "autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture", loading: "lazy", style: { borderRadius: '10px' } }) }));
    }
    // YouTube Embed
    if (data.embed_type === 'youtube' && data.video_id) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "discord-link-embed youtube-embed", style: { borderLeft: `4px solid ${accentColor}` }, children: [(0, jsx_runtime_1.jsx)("div", { className: "embed-provider-row", children: (0, jsx_runtime_1.jsx)("span", { className: "embed-provider-name", style: { color: '#949ba4' }, children: data.provider || 'YouTube' }) }), data.author && ((0, jsx_runtime_1.jsx)("div", { className: "embed-author-row", children: (0, jsx_runtime_1.jsx)("a", { href: data.author_url || '#', target: "_blank", rel: "noopener noreferrer", className: "embed-author-link", children: data.author }) })), data.title && ((0, jsx_runtime_1.jsx)("div", { className: "embed-title-row", children: (0, jsx_runtime_1.jsx)("a", { href: data.url, target: "_blank", rel: "noopener noreferrer", className: "embed-title-link", children: data.title }) })), (0, jsx_runtime_1.jsx)("div", { className: "embed-video-container", children: (0, jsx_runtime_1.jsx)("iframe", { src: `https://www.youtube.com/embed/${data.video_id}?autoplay=0`, title: data.title || 'YouTube', frameBorder: "0", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true, className: "youtube-iframe" }) })] }));
    }
    // SoundCloud Embed (Matching Discord Screenshot 1)
    if (data.embed_type === 'soundcloud') {
        const soundcloudEmbedSrc = `https://w.soundcloud.com/player/?url=${encodeURIComponent(data.url)}&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=true`;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "discord-link-embed soundcloud-embed", style: { borderLeft: `4px solid ${accentColor}` }, children: [(0, jsx_runtime_1.jsx)("div", { className: "embed-provider-row", children: (0, jsx_runtime_1.jsx)("span", { className: "embed-provider-name", children: data.provider || 'SoundCloud' }) }), data.author && ((0, jsx_runtime_1.jsx)("div", { className: "embed-author-row", children: (0, jsx_runtime_1.jsx)("span", { className: "embed-author-text", children: data.author }) })), data.title && ((0, jsx_runtime_1.jsx)("div", { className: "embed-title-row", children: (0, jsx_runtime_1.jsx)("a", { href: data.url, target: "_blank", rel: "noopener noreferrer", className: "embed-title-link", children: data.title }) })), (0, jsx_runtime_1.jsx)("div", { className: "soundcloud-media-container", children: isPlayingSoundCloud ? ((0, jsx_runtime_1.jsx)("iframe", { width: "100%", height: "300", scrolling: "no", frameBorder: "no", allow: "autoplay; encrypted-media", src: soundcloudEmbedSrc, style: { borderRadius: '8px', border: 'none' } })) : data.thumbnail ? ((0, jsx_runtime_1.jsxs)("div", { className: "soundcloud-artwork-box", onClick: () => setIsPlayingSoundCloud(true), title: "SoundCloud'da \u00C7al", children: [(0, jsx_runtime_1.jsx)("img", { src: data.thumbnail, alt: "", className: "soundcloud-artwork-img" }), (0, jsx_runtime_1.jsx)("div", { className: "soundcloud-play-overlay", children: (0, jsx_runtime_1.jsx)("div", { className: "soundcloud-play-button", children: (0, jsx_runtime_1.jsx)(lucide_react_1.Play, { size: 26, fill: "white", color: "white", style: { marginLeft: '3px' } }) }) })] })) : ((0, jsx_runtime_1.jsx)("iframe", { width: "100%", height: "166", scrolling: "no", frameBorder: "no", allow: "autoplay; encrypted-media", src: soundcloudEmbedSrc, style: { borderRadius: '8px', border: 'none' } })) })] }));
    }
    // Generic Rich Link / Webpage Card
    return ((0, jsx_runtime_1.jsxs)("div", { className: "discord-link-embed generic-embed", style: { borderLeft: `4px solid ${accentColor}` }, children: [data.provider && ((0, jsx_runtime_1.jsx)("div", { className: "embed-provider-row", children: (0, jsx_runtime_1.jsx)("span", { className: "embed-provider-name", children: data.provider }) })), data.author && ((0, jsx_runtime_1.jsx)("div", { className: "embed-author-row", children: (0, jsx_runtime_1.jsx)("span", { className: "embed-author-text", children: data.author }) })), data.title && ((0, jsx_runtime_1.jsx)("div", { className: "embed-title-row", children: (0, jsx_runtime_1.jsx)("a", { href: data.url, target: "_blank", rel: "noopener noreferrer", className: "embed-title-link", children: data.title }) })), data.description && ((0, jsx_runtime_1.jsx)("div", { className: "embed-description-text", children: data.description })), data.thumbnail && ((0, jsx_runtime_1.jsx)("div", { className: "embed-thumbnail-container", onClick: () => onImageClick?.(data.thumbnail), children: (0, jsx_runtime_1.jsx)("img", { src: data.thumbnail, alt: "", className: "embed-thumbnail-img" }) }))] }));
};
exports.LinkPreviewCard = LinkPreviewCard;
